import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useSpring, animated } from 'react-spring'

import Icon from 'components/Icon'

import './done-indicator.pcss'

const DoneIndicator = ({ text, className }) => {
    const [display, setDisplay] = useState(true)

    const style = useSpring({
        delay: 1500,
        from: { opacity: 1 },
        to: { opacity: 0 },
        onRest: () => {
            setDisplay(false)
        }
    })

    return display ? (
        <animated.div style={style} className={classNames('done-indicator', className)}>
            <Icon fa name="check" color="#66aa00" /> {text}
        </animated.div>
    ) : null
}

DoneIndicator.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
}

export default DoneIndicator
